import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AuthService = {
    validateToken: async () => axios.get(API_URL + "/api/validate-token").then(({data}) => data).catch(err => {throw err})
};

export default AuthService;